import { Container, Row, Col } from '@geberit/gdds';

// style
import styles from './iframe.module.scss';

// components
import Iframe from './iframe';
import { Headline, Formats, getFontWeight } from 'components/ContentElements/Headline';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { classNameBuilder } from 'utils/classNameBuilder';
import { buildSize, gridSizes } from 'utils/gridSize';
import { useThemeName } from 'utils/hooks/use-theme';
import { useSectionId } from 'utils/hooks/use-section-id';

export interface IframeWrapperProps {
  target: string;
  title?: string;
  subtitle?: string;
  emphasize: string;
  content?: string;
  contentIndex?: number;
  childOf?: string;
  position?: string;
  backgroundColor?: string;
}

export function IframeWrapper({
  target,
  title,
  subtitle,
  emphasize,
  content,
  contentIndex,
  childOf,
  position,
  backgroundColor = 'white',
}: Readonly<IframeWrapperProps>) {
  const themeName = useThemeName();
  const twoThirdGrid = position === 'full';
  const sectionId = useSectionId(title ?? '', '', false, contentIndex);

  return (
    <div
      className={classNameBuilder(
        styles.wrapper,
        styles[`${backgroundColor}Background`],
        childOf === 'tab' && styles.isChild,
      )}
      id={sectionId}
    >
      <Container
        maxContentWidth={twoThirdGrid ? buildSize(gridSizes.twoThird) : buildSize(gridSizes.full)}
      >
        {(title || subtitle) && (
          <Row>
            <Col>
              <Headline
                title={title}
                subtitle={subtitle}
                format={Formats.h2}
                titleFontWeight={getFontWeight(emphasize === 'title', themeName, Formats.h2)}
                subtitleFontWeight={getFontWeight(emphasize === 'subtitle', themeName, Formats.h2)}
                titlePreviewId="#st_title"
                subtitlePreviewId="#st_subtitle"
              />
            </Col>
          </Row>
        )}
        {content && (
          <Row className={styles.content}>
            <Col>
              <InnerHtml as="p" content={content} isGdds previewId="#st_content" />
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <Iframe src={target} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
